import React from 'react';
import Stopwatch from './Stopwatch';
// Import the hook for accessing the stopwatch context
import { useStopwatchContext } from '../contexts';
// Import PaceDataStorage instead of ReviewModeView
import PaceDataStorage from './PaceDataStorage';

const StopwatchApp: React.FC = () => {
  // Use the stopwatch context
  const {
    workoutSessions,
    workoutTimerRef,
    isReviewMode,
    toggleReviewMode,
    deleteWorkoutSession,
    paceUnit,
    togglePaceUnit,
  } = useStopwatchContext();

  return (
    <>
      {/* Render PaceDataStorage directly when in review mode */}
      {isReviewMode && (
        <div
          className="review-mode-container"
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10 }}
        >
          <PaceDataStorage
            workoutSessions={workoutSessions}
            onDeleteSession={deleteWorkoutSession}
          />
        </div>
      )}

      {/* Always render the stopwatch view, it will run in the background */}
      <div
        className={`stopwatch-app stopwatch-app--centered ${isReviewMode ? 'stopwatch-app--hidden' : ''}`}
        style={{ opacity: isReviewMode ? 0 : 1, pointerEvents: isReviewMode ? 'none' : 'auto' }}
      >
        <div className="stopwatch-container">
          <Stopwatch ref={workoutTimerRef} />
        </div>

        {/* Review Workout History button at the bottom */}
        <div className="stopwatch-controls">
          {/* Pace Unit Toggle Button */}
          <button
            onClick={togglePaceUnit}
            className="stopwatch-controls__toggle stopwatch-controls__toggle--pace-unit"
          >
            {paceUnit === 'mile' ? 'Switch to km' : 'Switch to miles'}
          </button>

          <button onClick={toggleReviewMode} className="stopwatch-controls__toggle">
            Workout History
          </button>
        </div>
      </div>
    </>
  );
};

export default StopwatchApp;
